<template>
  <div>
    <modalWindow v-model="showModel" @ok="createSubmit()" @cancel="cancel()" @closed="onClose()" title="Zmena hesla" :cancelText="'Zrušiť'" :okText="'Uložiť'" :small="true">
      <form>
        <div class="row">
          <div class="col-md-12">

            <text-field field-id="newPassword"
                        label="Nové heslo"
                        placeholder="Zadaj nové heslo"
                        v-model="credentials.newPassword"
                        :maxlength="20"
                        ref="newPassword"
                        type="password"
                        data-vv-value-path="value"
                        data-vv-name="newPassword"
                        v-validate="'required|min:5|max:20'"
            ></text-field>
            <text-field field-id="confirmPassword"
                        label="Nové heslo pre kontrolu"
                        placeholder="Zadaj nové heslo znova"
                        v-model="credentials.confirmPassword"
                        :maxlength="20"
                        type="password"
                        data-vv-value-path="value"
                        data-vv-name="confirmPassword"
                        v-validate="'required|confirmed:$newPassword'"></text-field>
          </div>
        </div>
      </form>
    </modalWindow>
  </div>
</template>

<script>
  import _ from 'lodash';
  import modal from 'vue-strap/src/Modal';
  import validationMixin from 'components/validationMixin';
  import notificationService from 'services/notificationService';
  import textField from 'components/form/textField';
  export default {
    components: {modalWindow: modal, textField},
    mixins: [validationMixin],
    data: () => ({
      credentials: {
        newPassword: null,
        confirmPassword: null
      }
    }),
    computed: {
      editMode() {
        return this.user && this.user.id
      }
    },
    props: {
      showModel: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object
      }
    },
    methods: {
      createSubmit() {
        this.protect();
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.$store.dispatch('user/passwordChange', {credentials: this.credentials, userId: this.user.id}).then((result) => {
              if (result) {
                notificationService.success('Heslo bolo zmenené.');
                this.$emit('close');
              } else {
                this.unprotect();
              }
            }).catch(this.unprotect);
          } else {
            this.unprotect();
          }
        }).catch(this.unprotect);
      },
      cancel() {
        this.$emit('close');
      },
      onClose() {
        this.credentials.newPassword = null;
        this.credentials.confirmPassword = null;
        this.unprotect();
        this.$nextTick(() => {
          this.errors.clear();
        });
      }
    },
    watch: {
      model: function (model) {
        if (model) {
          this.user = _.cloneDeep(model);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/passwordChangeModal.vue